export default "/_next/static/chunks/fonts/Montserrat-ExtraBoldItalic-latin-0d5389853df733fc5bcb173280ecd004.woff2";